import { useEffect, useState } from 'react'
import Eye from '../../assets/eye.svg?react'
import Moon from '../../assets/moon.svg?react'
import Sun from '../../assets/sun.svg?react'
import { IconButton } from '../icon-button'
import s from './theme-switch.module.css'


const ThemeSwitch = () => {
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light')

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme)
        localStorage.setItem('theme', theme)
    }, [theme])

    const onClick = (newTheme: string) => {
        setTheme(newTheme)
    }

    // See index.css
    const themes = ['light', 'dark', 'high-contrast']

    const getComponent = (theme: string) => {
        if (theme === 'light') return Sun
        if (theme === 'dark') return Moon
        return Eye
    }

    return <div className={s['theme-switch']}>
        {
            themes.map(t => (
                <IconButton
                    key={t}
                    onClick={() => onClick(t)}
                    icon={getComponent(t)}
                />
            ))
        }
    </div>
}

export default ThemeSwitch
